var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useEffect, useState } from "react";
import AonPannel from "../../components/core/AonPannel";
import { UuiFlexlayout, UuiSpinner } from "@aonunited/react";
import { AonButton } from "../../components/core/AonButton";
import { BUTTON_VARIANT } from "../../components/core/AonButton/consts";
import { getMarketTypeSpecific } from "../../api/marketData/apiSubscribedEntities";
import { getDDMMYYYY } from "../../constants/utilities";
import AonAgGridTable from "../../components/core/AonAgGridTable/table";
import { Link } from "react-router-dom";
export var MarketTypeSpecificPan = function (props) {
    var _a = useState({
        column_one: [],
        column_two: [],
        column_three: [],
    }), marketTypeSpecific = _a[0], setMarketTypeSpecific = _a[1];
    var _b = useState(false), marketTypeSpecificLoader = _b[0], setMarketTypeSpecificLoader = _b[1];
    var _c = useState({ showCarrierMatrix: false, rowData: [] }), marketTypeCarrierMatrix = _c[0], setMarketTypeCarrierMatrix = _c[1];
    var _d = useState(false), errorMarketSpecific = _d[0], setErrorMarketSpecific = _d[1];
    var id = props.id;
    useEffect(function () {
        fetchMarketTypeSpecificData();
    }, []);
    var fetchMarketTypeSpecificData = function () { return __awaiter(void 0, void 0, void 0, function () {
        var marketSpecificDataRes, c_one_1, c_two_1, c_three_1, item_1, sortedKeys, error_1;
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    if (!id) return [3 /*break*/, 4];
                    _d.label = 1;
                case 1:
                    _d.trys.push([1, 3, , 4]);
                    setMarketTypeSpecificLoader(true);
                    return [4 /*yield*/, getMarketTypeSpecific(id)];
                case 2:
                    marketSpecificDataRes = _d.sent();
                    c_one_1 = [];
                    c_two_1 = [];
                    c_three_1 = [];
                    item_1 = marketSpecificDataRes.data.value[0];
                    sortedKeys = ["consortiums", "contactInfo", "businessApprover", "eandO", "marketSubType"];
                    sortedKeys.forEach(function (key) {
                        var itemValue = item_1[key];
                        if (itemValue && typeof itemValue === 'object' && (itemValue).applicableToMarketFlag) {
                            if (key === "consortiums") {
                                c_one_1.push({
                                    name: "Consortium Number",
                                    value: itemValue.consortiumNumber,
                                });
                            }
                            else if (key === "contactInfo") {
                                c_one_1.unshift({
                                    name: "Contact Name",
                                    value: itemValue.contactName,
                                });
                                c_two_1.unshift({
                                    name: "Contact Phone Number",
                                    value: itemValue.contactPhoneNumber,
                                });
                                c_three_1.unshift({
                                    name: "Contact Email",
                                    value: itemValue.contactEmail,
                                });
                            }
                            else if (key === "businessApprover") {
                                c_one_1.push({
                                    name: "Business Approver",
                                    value: itemValue.businessApprover,
                                });
                            }
                            else if (key === "eandO") {
                                c_one_1.push({
                                    name: "E & O Insurance",
                                    value: itemValue.eandOLimit,
                                });
                            }
                            else if (key === "marketSubType") {
                                c_one_1.push({
                                    name: "Market Sub Type",
                                    value: itemValue.marketSubTypeName,
                                });
                            }
                        }
                    });
                    if ((_a = item_1.carrierMatrix) === null || _a === void 0 ? void 0 : _a.applicableToMarketFlag) {
                        setMarketTypeCarrierMatrix({ showCarrierMatrix: true, rowData: Array.isArray((_b = item_1.carrierMatrix) === null || _b === void 0 ? void 0 : _b.carriers) ? (_c = item_1.carrierMatrix) === null || _c === void 0 ? void 0 : _c.carriers : [] });
                    }
                    setMarketTypeSpecific({ column_one: c_one_1, column_two: c_two_1, column_three: c_three_1 });
                    setMarketTypeSpecificLoader(false);
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _d.sent();
                    setMarketTypeSpecificLoader(false);
                    setErrorMarketSpecific(true);
                    console.log("error", error_1);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var MarketTypeSpecificBody = function () {
        return marketTypeSpecificLoader ?
            React.createElement("div", { style: { display: "flex", alignItems: "center", width: "800px" } },
                React.createElement(UuiSpinner, { style: { marginLeft: "auto" }, variant: "small" })) : !errorMarketSpecific ?
            React.createElement("div", null,
                React.createElement(UuiFlexlayout, { direction: "row", gap: "lg" },
                    React.createElement("div", { className: "one-third-width" }, marketTypeSpecific.column_one.map(function (data, index) {
                        return React.createElement("div", { key: index, style: { padding: "12px", } },
                            React.createElement("div", { key: index + 1, style: { marginBottom: "7px", color: "grey" }, children: data.name }),
                            data.element ? data.element : React.createElement("span", { key: index + 2, style: { marginTop: "5px", marginInline: "auto" } }, data.value));
                    })),
                    React.createElement("div", { className: "one-third-width" },
                        " ",
                        marketTypeSpecific.column_two.map(function (data, index) {
                            return React.createElement("div", { key: index, style: { padding: "12px", } },
                                React.createElement("div", { key: index + 1, style: { marginBottom: "7px", color: "grey" }, children: data.name }),
                                data.element ? data.element : React.createElement("span", { key: index + 2, style: { marginTop: "5px", marginInline: "auto" } }, data.value));
                        })),
                    React.createElement("div", { className: "one-third-width" },
                        " ",
                        marketTypeSpecific.column_three.map(function (data, index) {
                            return React.createElement("div", { key: index, style: { padding: "12px", } },
                                React.createElement("div", { key: index + 1, style: { marginBottom: "7px", color: "grey" }, children: data.name }),
                                data.element ? data.element : React.createElement("span", { key: index + 2, style: { marginTop: "5px", marginInline: "auto" } }, data.value));
                        }))),
                marketTypeCarrierMatrix.showCarrierMatrix && React.createElement(React.Fragment, null,
                    React.createElement("h3", null, "Carrier Matrix"),
                    React.createElement("div", null,
                        React.createElement(AonAgGridTable, { height: 320, rowData: marketTypeCarrierMatrix.rowData, columns: columns(), loading: false, pagination: false }))))
            :
                React.createElement("div", null,
                    React.createElement(AonButton, { style: { paddingInline: "5px" }, variant: BUTTON_VARIANT.TEXT, onClick: function () { return fetchMarketTypeSpecificData(); } }, "Retry"));
    };
    return (!marketTypeSpecificLoader && !marketTypeSpecific.column_one.length) ? null : React.createElement(AonPannel, { headerTitle: "Market Type Specific", Body: React.createElement(MarketTypeSpecificBody, null) });
};
export var columns = function () {
    var CarrierMarketname = function (info) {
        var rowData = info.data;
        var navigationLink = "/market-details?MarketId=" + (rowData === null || rowData === void 0 ? void 0 : rowData.carrierMarketId);
        return React.createElement(Link, { to: navigationLink, target: '_blank' },
            React.createElement("span", { className: "marketDetailsTextDecoration" }, info.getValue()));
    };
    var FormatDate = function (info) { return (React.createElement("span", null, getDDMMYYYY(info.getValue()))); };
    return [
        { field: "carrierMarketName", cellRenderer: CarrierMarketname, headerName: "Market Name", sortable: false, flex: 2, minWidth: 100 },
        { field: "carrierInceptionDate", cellRenderer: FormatDate, headerName: "Inception Date", sortable: false, flex: 1, minWidth: 75 },
        { field: "carrierExpirationDate", cellRenderer: FormatDate, headerName: "Expiration Date", sortable: false, flex: 1, minWidth: 75 },
        { field: "carrierReinsuranceInsuranceIndicatorName", headerName: "Insurance Indicator", sortable: false, flex: 1, minWidth: 75 },
    ];
};
